/**
 * The fields a readiness check can find missing, as the projector's codes, in the order a person
 * fills a form. Mirrors the codes of its `patientReadiness` and `policyholderReadiness`, which
 * `backendContract` pins.
 */
// eslint-disable-next-line import/prefer-default-export
export const MISSING_DETAILS = [
  'missingLastName',
  'missingDateOfBirth',
  'missingGender',
  'missingAddress',
  'missingMemberId',
];
